function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgDanceAndAerobics(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: props.fill,
    strokeWidth: 0.4
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M16.092 10.611a2.523 2.523 0 002.684-2.689 2.542 2.542 0 00-2.356-2.36 2.527 2.527 0 00-2.684 2.69c.082 1.257 1.1 2.285 2.356 2.36z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M22.921 19.92c.213.411.624.642 1.059.642a1.19 1.19 0 001.05-1.735l-2.29-4.433a1.125 1.125 0 00-.484-.493l-4.276-2.369a1.173 1.173 0 00-.575-.148h-2.134c-.361 0-.706-.172-.928-.46L11.38 7V3.227c0-.642-.492-1.193-1.132-1.226A1.195 1.195 0 009 3.194v4.21c0 .263.082.51.238.724l2.077 2.746a5.868 5.868 0 011.165 3.109 25.33 25.33 0 00.944 5.255L9.936 24.32s0 .008-.008.008c-.009.008-.009.017-.017.025-.016.024-.033.05-.04.074-.01.008-.01.016-.017.024a.293.293 0 00-.033.075c0 .008-.008.016-.008.016a1.99 1.99 0 00-.066.205v.017c-.008.033-.008.058-.016.09v.025c0 .033-.009.074-.009.107v6.472c0 .641.493 1.192 1.133 1.225a1.19 1.19 0 001.248-1.192v-6.012l3.767-3.741a.296.296 0 01.452.033l2.593 3.544 3.423 6.71a1.2 1.2 0 001.059.65 1.19 1.19 0 001.059-1.735l-3.464-6.785-1.978-4.12a14.964 14.964 0 01-.985-3.47c-.123-.79-.18-1.587-.172-2.385l2.946 1.629 2.118 4.111z",
    fill: props.fill
  }));
}

export default SvgDanceAndAerobics;